import type { WritableAtom } from 'jotai';
import { getDefaultStore } from 'jotai';

const defaultStore = getDefaultStore();

export const createStoreService = <Value, Args extends unknown[], Result>(atom: WritableAtom<Value, Args, Result>) => ({
  get: () => defaultStore.get(atom),
  set: (...value: Args) => defaultStore.set(atom, ...value),
  sub: (listener: () => void) => defaultStore.sub(atom, listener),
});
